"use client";

import { criarClienteBrowser } from "@/core/supabase/client";

export function BotaoGoogle({ next = "/painel", rotulo = "Entrar com Google" }: { next?: string; rotulo?: string }) {
  async function entrarComGoogle() {
    const supabase = criarClienteBrowser();
    // basePath (deploy num path, ex.: /professores): o redirectTo PRECISA do
    // prefixo, senao o retorno do Google cai fora do app. Vazio = raiz (subdominio).
    const base = process.env.NEXT_PUBLIC_BASE_PATH ?? "";
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${location.origin}${base}/auth/callback?next=${encodeURIComponent(next)}`,
      },
    });
  }

  return (
    <button
      type="button"
      onClick={entrarComGoogle}
      className="flex w-full items-center justify-center gap-2 rounded-[10px] border border-[#2a2a2a] bg-[#1f1f1f] px-4 py-3 text-sm font-medium text-[#ededed] transition-colors hover:bg-[#262626]"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1Z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
        <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.16-3.16A11 11 0 0 0 2.18 7.06L5.84 9.9C6.71 7.31 9.14 5.38 12 5.38Z" />
      </svg>
      {rotulo}
    </button>
  );
}
